module.exports = __webpack_public_path__ + "img/klingon.9a19c29b.svg";